import { PhotosRemovePhotoReducer } from './types';

export const photosRemovePhotoReducer: PhotosRemovePhotoReducer = (
  state,
  action
) => {
  const { photoId } = action.payload;

  return {
    ...state,
    selectedPhotos: state.selectedPhotos.filter((photo) => photo !== photoId),
    unverifiedPhotos: state.unverifiedPhotos?.filter(
      (photo) => photo.id !== photoId
    ),
    approvedPhotos: state.approvedPhotos?.filter(
      (photo) => photo.id !== photoId
    ),
  };
};
